export default import.meta.ROLLDOWN_FILE_URL_CqPR5nL4YDDwNUsPgo$6sA